import {Component, EventEmitter, Input, Output} from "@angular/core";
import {localizationKey} from "../../../../i18n/i18n-model";
import {NurseSettings} from "../edit-hospital.service";
import {ReleaseToggleState} from "../../../../tools/release-toggles/release-toggle-state";

export type ReportDeliveryNotification = "NONE" | "INITIATING_NURSE" | "ALL_HOSPITAL_NURSES";


@Component({
    selector: "app-nurse-settings-section",
    templateUrl: "./nurse-settings-section.component.html",
    standalone: false
})
export class NurseSettingsSectionComponent {

  @Input() nurse2Fa!: boolean;
  @Input() reportDeliveryNotification!: ReportDeliveryNotification;
  @Input() initiateWithDeviceSerial!: boolean;
  @Input() hospitalId!: number;

  @Output() settingsChanged = new EventEmitter<NurseSettings>();

  protected readonly localizationKey = localizationKey;
  feature439Released = ReleaseToggleState.getInstance().isReleased("INITIATE_WITH_DEVICE_SERIAL_439");

  onNurse2FaChange(value: boolean) {
    this.nurse2Fa = value;
    this.emitSettings();
  }

  onInitiateWithDeviceSerialChange(value: boolean) {
    this.initiateWithDeviceSerial = value;
    this.emitSettings();
  }

  onReportDeliveryNotificationChange(value: ReportDeliveryNotification) {
    this.reportDeliveryNotification = value;
    this.emitSettings();
  }

  private emitSettings() {
    this.settingsChanged.emit({
      hospitalId: this.hospitalId,
      nurse2Fa: this.nurse2Fa,
      reportDeliveryNotification: this.reportDeliveryNotification,
      initiateWithDeviceSerial: this.initiateWithDeviceSerial
    });
  }
}
